import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import CardHeader from "peggirkit/dist/components/Card/CardHeading/CardHeader";
import {Alert, Card, SimpleCardHeading} from "peggirkit";
import {FormattedMessage} from "react-intl";
import {PosOrderForm} from "@/data/entities/order";
import {useFormContext, useWatch} from "react-hook-form";
import AccountTypeSelector from "./accountType/AccountTypeSelector";
import GuestPersonalInformation from "@widgets/pos/order/customer/personalDetails/guest/GuestPersonalInformation";
import CustomerSelector from "@widgets/pos/order/customer/personalDetails/existingCustomer/CustomerSelector";
import {useExistingOrder} from "@widgets/pos/order/hooks/UseExistingOrder";


const PersonalDetailsCard = (tabProps: OrderEditorTabProps) => {
    const {control} = useFormContext<PosOrderForm>();
    const customerType = useWatch<PosOrderForm>({control, name: "customerType"});
    const isExistingOrder: boolean = useExistingOrder() !== null; // The account of a placed order can't be changed
    return (
        <Card
            header={
                <CardHeader>
                    <SimpleCardHeading
                        title={<FormattedMessage id={"personalDetails"}/>}
                    />
                </CardHeader>
            }
        >
            <div className={"flex flex-col gap-6"}>
                {
                    isExistingOrder
                        ? <Alert
                            type={"primary"}
                            title={
                                <FormattedMessage
                                    id={customerType === "EXISTING" ? "orderOfAccount" : "orderWithoutAccount"}
                                />
                            }
                            content={<FormattedMessage id={"accountCannotBeChanged"}/>}
                        />
                        : <AccountTypeSelector {...tabProps}/>
                }

                {
                    customerType === "EXISTING"
                        ? <CustomerSelector {...tabProps}/>
                        : <GuestPersonalInformation {...tabProps}/>
                }
            </div>
        </Card>
    );
};

export default PersonalDetailsCard;